// extracted by mini-css-extract-plugin
module.exports = {"link":"dh-dh-klima-spesial-link--491ae842b754bb6e07527e4030cd033a","logo":"dh-dh-klima-spesial-logo--46875081d8e4c0f03343a427c27ad39c"};